import React from "react";

import "./hero.styles.scss";
import TruckImg from "../../assets/Hero.png";
import { ReactComponent as Logo2 } from "../../assets/Icon1.svg";
import { ReactComponent as Logo3 } from "../../assets/Icon2.svg";
import { ReactComponent as Logo4 } from "../../assets/Icon3.svg";

const Hero = () => {
  return (
    <section className="hero">
      <div className="hero__img">
        <img src={TruckImg} alt="" />
      </div>
      <div className="icons">
        <div className="icon">
          <Logo2 className="icon__img"/>
          <div className="icon__info">
            <p className="icon__top">Location</p>
            <p className="icon__bottom">Illinois</p>
          </div>
        </div>
        <div className="icon">
          <Logo3 className="icon__img"/>
          <div className="icon__info">
            <p className="icon__top">Service</p>
            <p className="icon__bottom">Outstanding</p>
          </div>
        </div>
        <div className="icon">
          <Logo4 className="icon__img"/>
          <div className="icon__info">
            <p className="icon__top">Quality</p>
            <p className="icon__bottom">Exceptional</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
